import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

export const PolicyImg = styled.img.attrs(() => ({
  src: 'img/policy.svg',
}))`
  width: 84px;
  height: 85px;
`;

export const Title = styled.h1`
  font-family: Arial, serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0;
  text-align: center;
  margin: 22px 0 8px;
`;

export const Description = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0;
  text-align: center;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin: 40px 10px 18px;
`;

export const Checkbox = styled.input.attrs(() => ({
  type: 'checkbox',
}))`
  margin-right: 12px;
`;

export const Label = styled.label`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0;
  text-align: left;

  a {
    color: #333;
    text-decoration: underline;
    font-family: Roboto, sans-serif;
  }
`;
